// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
    apiKey: "AIzaSyCOaZ4J62gzpc_U8uvWV4AEeyuP9LJnEo8",
    authDomain: "apptlsch-9307c.firebaseapp.com",
    projectId: "apptlsch-9307c",
    storageBucket: "apptlsch-9307c.appspot.com",
    messagingSenderId: "674250637909",
    appId: "1:674250637909:web:2f2f6083ad4966fe23cadc",
    measurementId: "G-X8KFQSLJ2N"
};

const app = initializeApp(firebaseConfig);

export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
